import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader, Stat, StatusBadge } from "@/components/admin/common";
import { DailyChart, MonthlyChart } from "@/components/admin/TrafficChart";
import { RangePicker, PrivacyNote } from "@/pages/CardAnalytics";
import { api } from "@/lib/api";

export default function Analytics() {
  const nav = useNavigate();
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/analytics/overview", { params: { days } }).then((r) => setData(r.data));
  }, [days]);
  const t = data?.totals || {};
  return (
    <div>
      <PageHeader eyebrow="Analitiche" title="Statistiche" description="Dati aggregati su tutte le card."><RangePicker days={days} setDays={setDays} /></PageHeader>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Stat label="Visite" value={t.views ?? "–"} testId="overview-views" />
        <Stat label="Da QR" value={t.qr_views ?? "–"} testId="overview-qr" />
        <Stat label="Click Salva contatto" value={t.vcard_downloads ?? "–"} hint="Download .vcf" testId="overview-vcard" />
        <Stat label="Click link" value={t.link_clicks ?? "–"} testId="overview-clicks" />
      </div>
      <div className="mt-6 grid gap-6 lg:grid-cols-2">
        <div className="panel p-6"><div className="eyebrow mb-4">Giornaliero</div>{data && <DailyChart data={data.daily} />}</div>
        <div className="panel p-6"><div className="eyebrow mb-4">Mensile</div>{data && <MonthlyChart data={data.monthly} />}</div>
      </div>
      <div className="panel mt-6 overflow-x-auto" data-testid="analytics-per-card">
        <table className="w-full min-w-[640px] text-sm">
          <thead><tr className="border-b text-left">{["Card", "Cliente", "Stato", "Visite", "QR", "Salva contatto", "Click"].map((h) => <th key={h} className="eyebrow px-5 py-3 font-normal">{h}</th>)}</tr></thead>
          <tbody>
            {(data?.per_card || []).map((c) => (
              <tr key={c.id} className="cursor-pointer border-b last:border-0 hover:bg-zinc-50/70" onClick={() => nav(`/admin/card/${c.id}/statistiche`)}>
                <td className="px-5 py-3 font-medium">{c.name}<div className="font-mono-ui text-[11px] font-normal text-zinc-400">/c/{c.slug}</div></td>
                <td className="px-5 py-3 text-zinc-600">{c.client_name}</td>
                <td className="px-5 py-3"><StatusBadge status={c.status} /></td>
                {["views", "qr_views", "vcard", "clicks"].map((k) => <td key={k} className="px-5 py-3 tabular-nums">{c[k]}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <PrivacyNote />
    </div>
  );
}
